import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { Link } from "react-router-dom";
import { ShareContentModal } from "../components/content/share-content-modal";
import { SubmitButton } from "../components/shared/buttons/submit-button";
import Card from "../components/shared/card";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import { extractFirstImageUrl } from "../components/utls/utils";
import useLoadContent from "../hooks/useLoadContent";

const ContentListPage = () => {
  const { content, isLoading, error } = useLoadContent();
  const [openShareId, setOpenShareId] = useState<string | null>(null);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner size="lg" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta">
          Failed to load content
        </Typography>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Typography variant="h2" className="mb-8 text-terracotta">
        Content
      </Typography>
      <div className="grid gap-6 mb-24">
        {content?.map((item) => {
          const title =
            (item as any).title || item?.text?.split("**")[1] || "Untitled";
          const snippet = item?.snippet || "";

          let imageUrl = item.title_img_url || "";
          if (!imageUrl) {
            imageUrl = extractFirstImageUrl(item?.text) || "";
          }

          return (
            <Card
              key={item.id}
              className="w-full relative"
              variant="cream"
              elevation={1}
              hoverEffect
            >
              <SubmitButton
                size="sm"
                iconOnly
                aria-label="Share content"
                color="cream"
                className="absolute top-1 right-1 z-10"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setOpenShareId(item.id);
                }}
                icon={<PaperAirplaneIcon className="w-4 h-4" />}
              />
              <Link
                to={`/content/${item.slug || item.id}`}
                className="flex justify-between"
              >
                <div className="p-4 flex flex-row gap-4 justify-between">
                  {imageUrl && (
                    <img
                      src={imageUrl}
                      alt={title}
                      className="w-48 h-48 object-cover rounded-r"
                    />
                  )}
                  <div>
                    <Typography
                      variant="h4"
                      className="text-terracotta mb-2 max-w-2xl"
                    >
                      {title}
                    </Typography>
                    <Typography variant="body2" className="text-brown-500">
                      {snippet}...
                    </Typography>
                  </div>
                </div>
              </Link>
              <ShareContentModal
                contentId={item.id}
                isOpen={openShareId === item.id}
                onClose={() => setOpenShareId(null)}
              />
            </Card>
          );
        })}
      </div>
    </div>
  );
};

export default ContentListPage;
